module.exports = __webpack_public_path__ + "img/杭州天街.0c0d0153.png";